const CLOUD_NAME = "dvltxvk49";

const FOLDER_ROOTS = ["customers/", "projects/", "registry/"];

/** Extract Cloudinary public_id from secure URL or pass through bare public id. */
export function extractCloudinaryPublicId(urlOrId) {
  if (!urlOrId) return null;
  const raw = String(urlOrId).trim();
  if (!raw) return null;

  if (!raw.includes("/upload/") && !raw.startsWith("http")) {
    return raw.replace(/\.[^/.]+$/, "");
  }

  const idx = raw.indexOf("/upload/");
  if (idx === -1) return null;

  let path = raw.substring(idx + "/upload/".length);
  const qIdx = path.indexOf("?");
  if (qIdx !== -1) path = path.substring(0, qIdx);
  path = path.replace(/^v\d+\//, "");

  for (let i = 0; i < 20; i++) {
    const hits = FOLDER_ROOTS.map((r) => path.indexOf(r)).filter((n) => n >= 0);
    if (hits.length === 0) break;
    const rootIdx = Math.min(...hits);
    if (rootIdx === 0) break;
    path = path.substring(rootIdx);
  }

  path = path.replace(/^\/+/, "");
  const extIdx = path.lastIndexOf(".");
  if (extIdx === -1) return path || null;
  return path.substring(0, extIdx) || null;
}

/** Square crop used for list/grid thumbnails. */
export const CLOUDINARY_THUMB_TRANSFORMATION =
  "c_fill,g_auto,w_240,h_240,q_auto,f_auto/";

/** Width-capped delivery used in the photo gallery. */
export const CLOUDINARY_VIEW_TRANSFORMATION = "c_limit,w_1600,q_auto,f_auto/";

/** Build HTTPS delivery URL from public id or return URL unchanged. */
export function toCloudinaryDeliveryUrl(value, transformation = "") {
  if (!value) return null;
  const s = String(value);
  if (s.startsWith("http://") || s.startsWith("https://")) {
    if (!transformation) return s;
    const idx = s.indexOf("/upload/");
    if (idx === -1) return s;
    return `${s.substring(0, idx + 8)}${transformation}${s.substring(idx + 8)}`;
  }
  const publicId = extractCloudinaryPublicId(s) || s;
  const tx = transformation ? `${transformation}` : "";
  return `https://res.cloudinary.com/${CLOUD_NAME}/image/upload/${tx}${publicId}`;
}

/** 240×240 thumbnail. Pass the original stored Cloudinary URL. */
export function getCloudinaryThumbUrl(url) {
  if (!url) return url;
  return toCloudinaryDeliveryUrl(url, CLOUDINARY_THUMB_TRANSFORMATION) || url;
}

/** Gallery-sized image (max 1600px wide). Pass the original stored Cloudinary URL. */
export function getCloudinaryViewUrl(url) {
  if (!url) return url;
  return toCloudinaryDeliveryUrl(url, CLOUDINARY_VIEW_TRANSFORMATION) || url;
}

export function getCloudinaryCloudName() {
  return CLOUD_NAME;
}
